import type { PlotMedia } from "./PlotMedia"
import type { PlotPath } from "./PlotPath"
import type { PlotRect } from "./PlotRect"
import type { PlotText } from "./PlotText"

// Union type of all possible shapes

export type PlotShape = PlotMedia | PlotPath | PlotRect | PlotText
